// extracted by mini-css-extract-plugin
module.exports = {"content":"editor-styles_content__5Vnap"};